export default "https://housescan.app.solease.nl/static/media/roof_insulation.5d2c5aaa.svg";